import { render, staticRenderFns } from "./playLottie.vue?vue&type=template&id=24c05a70&"
import script from "./playLottie.vue?vue&type=script&lang=js&"
export * from "./playLottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports